import React from "react";
import { SPUR_DISPLAY_STATUS } from "../../constants/spurDisplayStatus";

function PgStatusChip({ status, readyToComplete }) {
  if (readyToComplete) {
    return (
      <span className="pg-chip pg-chip--complete">
        {SPUR_DISPLAY_STATUS.READY_TO_COMPLETE}
      </span>
    );
  }
  const map = {
    [SPUR_DISPLAY_STATUS.ASSIGNED]: "pg-chip--assigned",
    [SPUR_DISPLAY_STATUS.IDLE]: "pg-chip--unassigned",
    [SPUR_DISPLAY_STATUS.SUSPENDED]: "pg-chip--suspended",
  };
  const cls = map[status] || "pg-chip--unassigned";
  return <span className={`pg-chip ${cls}`}>{status}</span>;
}

export default PgStatusChip;
